import { formatBytes, toNumber } from './dbOverviewSections';

/**
 * The header facts of a database, per engine — what DBeaver's Properties tab
 * and DataGrip's database properties lead with. `[{ key, value }]`, empty
 * values dropped; `key` is the i18n key under dbOverview.fact.
 */
export function factsFor(engine, facts, { scope } = {}) {
  if (!facts) return [];
  let list;
  if (engine === 'mysql') {
    list = [
      ['size', formatBytes(facts.size)],
      ['charset', facts.charset],
      ['collation', facts.collation],
      ['server', facts.version],
    ];
  } else if (engine === 'postgres') {
    list = scope
      ? [
          ['schemaSize', formatBytes(facts.schemaSize)],
          ['schemaOwner', facts.schemaOwner],
          ['database', facts.name],
          ['databaseSize', formatBytes(facts.size)],
          ['encoding', facts.encoding],
          ['collation', facts.collation],
          ['server', facts.version],
        ]
      : [
          ['size', formatBytes(facts.size)],
          ['encoding', facts.encoding],
          ['collation', facts.collation],
          ['owner', facts.owner],
          ['server', facts.version],
        ];
  } else {
    const pages = toNumber(facts.pageCount);
    const pageSize = toNumber(facts.pageSize);
    list = [
      ['fileSize', pages != null && pageSize != null ? formatBytes(pages * pageSize) : ''],
      ['pages', pages != null && pageSize != null ? `${pages.toLocaleString()} × ${formatBytes(pageSize)}` : ''],
      ['freePages', facts.freePages == null ? '' : String(facts.freePages)],
      ['encoding', facts.encoding],
      ['server', facts.version ? `SQLite ${facts.version}` : ''],
    ];
  }
  return list
    .filter(([, v]) => v !== null && v !== undefined && String(v) !== '')
    .map(([key, value]) => ({ key, value: String(value) }));
}
